import { IEnvironment } from './environment.interface';

export const environment: IEnvironment = {
    production: false,
    /**
     * URL ABSOLUTA del gateway, y por eso ya no es `/api`.
     *
     * En el portal standalone era relativa a propósito, para que el `proxy.conf.json` del dev
     * server pudiera interceptarla. Bajo el shell eso es exactamente lo que rompe: una ruta
     * relativa se resuelve contra el origen ACTUAL —`shell.pc.tiskelia.io`—, esa ruta no existe
     * en el nginx del shell y, por ser una SPA, `try_files` devuelve el `index.html`. El cliente
     * intenta parsear HTML como JSON y muere con
     * `SyntaxError: Unexpected token '<', "<!doctype "... is not valid JSON`.
     *
     * Coincide con el `servicesUri` del `config.json` del shell (verificado), que es el valor que
     * el host publica en `NAIA_ENVIRONMENT` — así el remoto resuelve lo mismo lo inyecte quien lo
     * inyecte.
     *
     * DEUDA RESUELTA: los servicios que antes leían `environment.servicesUri` de forma ESTÁTICA
     * ahora inyectan `NAIA_ENVIRONMENT` (`@naia/shared-interfaces`) — así resuelven el gateway de
     * quien los hospede (shell federado o bootstrap standalone), en vez de dejarlo horneado en el
     * bundle. Este archivo queda como el DEFAULT del modo standalone: lo sigue publicando
     * `app.config.ts` (`{ provide: NAIA_ENVIRONMENT, useValue: environment }`), único lugar del
     * proyecto que importa `environment` de forma estática a propósito.
     */
    servicesUri: 'https://api.pc.tiskelia.io/api',
    profile: {
        name: 'naia-venpar',
        initComponent: 'dashboard',
        logo: 'assets/images/logos/venpar-global.png',
        companyName: 'Venpar Settlements - Dev'
    }
};
